var map = {
	"./pantalla-2-1.png": "b280",
	"./pantalla-2-10.png": "3e66",
	"./pantalla-2-11.png": "bc92",
	"./pantalla-2-12.png": "cf5b",
	"./pantalla-2-2.png": "192a",
	"./pantalla-2-3.png": "f062",
	"./pantalla-2-4.png": "1a55",
	"./pantalla-2-5.png": "551c",
	"./pantalla-2-6.png": "b20b",
	"./pantalla-2-7.png": "188d",
	"./pantalla-2-8.png": "1d30",
	"./pantalla-2-9.png": "2eb1",
	"./pantalla-2-sliders.png": "ddf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1344";